{
  "message": "Please confirm your email address. An installation administrator will then review your account. We will email you the decision. You can sign in once approved.",
  "title": "Your account isn't active yet",
  "waitsFor": {
    "approval": "An administrator still has to approve your account. Then you can sign in.",
    "confirm_email": "Confirm your email address with the link we sent you. Then you can sign in.",
    "confirm_email_then_approval": "Confirm your email address with the link we sent you. Then an administrator approves your account."
  }
}
